import { FormDialogMode } from '@globaleris/ui.library'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { EnumPriceType } from '../../../api/oData/enums/enumPriceType'
import Page from '../../../components/page/page'
import PageCenterColumn from '../../../components/page/pageCenterColumn'
import { PriceComponentTypeForm } from './components/priceComponentTypeForm'

interface PriceComponentTypeEditProps {
  location: {
    state: {
      commodity: number
    }
  }
}

export const PriceComponentTypeAdd: React.FC<PriceComponentTypeEditProps> = props => {
  const [t] = useTranslation(['globalerisLibrary', 'priceComponentType', 'enums'])
  const history = useHistory()

  const { commodity } = props.location?.state || {}
  if (!commodity) {
    history.goBack()
    return <></>
  }

  return (
    <Page>
      <PageCenterColumn title={t('priceComponentType:form.add.title')}>
        <PriceComponentTypeForm
          commodity={commodity}
          formMode={FormDialogMode.ADD}
          priceType={EnumPriceType.Parametro}
        />
      </PageCenterColumn>
    </Page>
  )
}
